import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mrn-input',
  templateUrl: './mrn-input.component.html',
  styleUrls: ['./mrn-input.component.scss'],
})
export class MrnInputComponent {
  @Input() control!: AbstractControl;
  @Input() currentUserId!: string;
  @Input() appearance: 'outline' | 'fill' | 'standard' | 'legacy' = 'outline';


  chartLink(userId: string): string {
    return `${environment.welbyBaseUrl}/clinical/patient-detail/${userId}/home`;
  }

  get error() {
    return this.control?.errors?.['mrnTaken'];
  }
}
